var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"confirm-workshop-section-content"}},[(_vm.error)?_c('div',[_c('h1',[_vm._v("Error")]),_c('h3',[_vm._v(_vm._s(_vm.message))])]):_c('div',[_c('h1',[_vm._v(_vm._s(_vm.message))])])])}
var staticRenderFns = []

export { render, staticRenderFns }